import z from "zod";

export const companyMetricsSchema = z.object({
  chargedKwh: z.number().min(0),
  sessions: z.number().min(0),
  chargingUsers: z.number().min(0),
});

export type CompanyMetrics = z.infer<typeof companyMetricsSchema>;
